// On a phone, a card of the member view folded to its heading and a 1-line summary ("Goal agreed 28 Jun"), opened
// with a tap, so the month's actions come first (the critique's admin 6). At laptop width the fold is open with its
// heading hidden, so it's the card as it is; the fold is always there, so a change of width never draws the card afresh
// and loses a form that's open in it. The card keeps its own heading for its name, out of sight inside the fold on a
// phone (admin-masterminds.css), and a link to it opens the fold (openAt).
import { usePhone } from '../../lib/media.js'

export function PhoneFold({ title, line, children }) {
  const phone = usePhone()
  return (
    <details className={`amx-pfold${phone ? ' amx-fold amx-pfold--phone' : ''}`} open={!phone}>
      <summary className="amx-fold-head" hidden={!phone}>
        <span className="amx-pfold-text">
          <h2 className="ad-card-title">{title}</h2>
          {line && <span className="amx-pfold-line">{line}</span>}
        </span>
      </summary>
      {children}
    </details>
  )
}

// A card on the page that a link points at, opened when it's folded: its own fold, or the fold it's in
export function openAt(target) {
  const el = target ? document.querySelector(target) : null
  const fold = el?.querySelector('details.amx-fold') || el?.closest('details.amx-fold')
  if (fold) fold.open = true
}
